import "./datePicker.css";
import { DatePicker } from "antd";
import dayjs from 'dayjs';


const PopupDatePicker = ({
  name,
  date,
  getDate,
  validation,
  min,
  max,
  onChange
}) => {
  const onChangeHandler = (date, dateString) => {
    if(dateString.length !== 0) {
      const [day, month, year] = dateString.split("/");  
      const formattedDate = `${year}-${month}-${day}`;
      getDate((date) => ({ ...date, [name]: formattedDate }));
    }
  };
  return (
    <div className={`date-picker-wrapper ${!validation ? "not-valid" : ""}`}>
      <label htmlFor={name}>
        Date <span>*</span>
      </label>
      <DatePicker
        name={name}
        maxDate={dayjs(max)}
        minDate={dayjs(min)}
        onChange={onChangeHandler}
        format={"DD/MM/YYYY"}
        value={date ? dayjs(date)  : ""}
        style={{ zIndex: 3100 }}
        onKeyDown={(e) => e.preventDefault()}
      />
    </div>
  );
};

export default PopupDatePicker;
